<script setup lang="ts">
import { watch } from "vue";

const props = defineProps<{
	data: boolean;
}>();

watch(
	() => props.data,
	(newValue) => {
		document.body.style.overflow = newValue ? "hidden" : "";
	},
);
</script>

<template></template>
